<template>
  <div id="app">
    <SideMenuNavigation />
    <TopNavigation />
    <section class="container section-feature-grey" style="min-height: 400px;">
      <transition
        name="fade"
        mode="out-in"
        @beforeLeave="beforeLeave"
        @enter="enter"
        @afterEnter="afterEnter"
      >
        <router-view />
      </transition>
    </section>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SideMenuNavigation from "@/components/SideMenuNavigation";
import TopNavigation from "@/components/TopNavigation";
export default {
  name: "app",
  created() {
    this.isAuthenticated();
  },
  components: {
    SideMenuNavigation,
    TopNavigation
  },
  data() {
    return {
      prevHeight: 0
    };
  },
  methods: {
    ...mapActions(["isAuthenticated"]),
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    }
  }
};
</script>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

$primary: #7cd1d3;
$secondary: #222222;
$accent: #7cd1d3;
// Set your colors
$primary-invert: findColorInvert($primary);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  )
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

.dropOut ul {
  margin-left: 0;
  margin-top: 0;
}

body {
  font-family: "Open Sans", Arial, Helvetica, sans-serif;
}

.modal.is-active .modal-background {
  background: rgba(10, 10, 10, 0.86) !important;
  width: 100% !important;
  height: 100% !important;
  position: absolute !important;
  border-radius: 0 !important;
  -webkit-transform: none !important;
  transform: none !important;
}

.animation-content {
  max-width: 960px;
  position: relative !important;
  z-index: 99 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity;
  transition-timing-function: ease-in-out;
  overflow: hidden;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.button.is-primary {
  color: #fff;
}
</style>
